module.exports = __webpack_public_path__ + "img/Weapon_114.949e723f.png";